module.exports = __webpack_public_path__ + "img/129-94e822.png";